/**
 * @file IconTipIllustrate Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-tip-illustrate',
  (data) => `
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg
  width="${data.size}"
  height="${data.size}"
  class="icon"
  p-id="33244"
  t="1682214073785"
  viewBox="0 0 1024 1024"
>
  <path
    fill="${data.colorDesc[0]}"
    d="M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 73.142857a438.857143 438.857143 0 1 0 0 877.714286A438.857143 438.857143 0 0 0 512 73.142857z m73.142857 365.714286v365.714286H438.857143V438.857143h146.285714zM512 219.428571a73.142857 73.142857 0 1 1 0 146.285715 73.142857 73.142857 0 0 1 0-146.285715z"
    p-id="33245"
  />
</svg>
`
);
